module.exports = __webpack_public_path__ + "media/images/sp/stores/sola/icon_title_1-04132daea4293ee664e814cf523d6113.svg";